import { HomeWorkspace } from "@/features/home";

export default function DashboardPage() {
  return <HomeWorkspace />;
}
